// libs.
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// slices.
import {
  setApproverTasks,
  setDefaultState,
} from '../../../domains/approver-review/slices/approver-task.slice';

// endpoints.
import { useGetApproverTasksListQuery } from '../../../domains/approver-review';

export const useFetchApproverTasks = (status: string, country: 'MX' | 'CO') => {
  const dispatch = useDispatch();

  const { data, isFetching, refetch } = useGetApproverTasksListQuery(
    { country, task_type: 'aprobologia', status },
    {
      skip: !country,
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      refetchOnReconnect: true,
      pollingInterval: 0,
    }
  );

  useEffect(() => {
    if (data) {
      dispatch(setApproverTasks(data));
    }
  }, [data, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setDefaultState());
    };
  }, [dispatch]);

  return {
    isFetching,
    data,
    refetch,
  };
};
